import React from 'react';
import { reduxConnect } from '../../common';
import type { IStoreState, Persistent320x50AdForMobileWeb } from '../common/interfaces/types';
import styled from 'styled-components';
import { withScreenSize } from '../common/utilities/withScreenSize.jsx';
import { DisplayAdWidget } from '../ads/displayAdWidget.jsx';
import { getPageCfgToRenderPersistent320x50Ad } from './utils';
import { DisplayAdUnit } from '../../containers/ads/displayAdUnitContainer';

type Persistent320x50MobileWebAdProps = {
    persistent320x50AdForMobileWeb: Persistent320x50AdForMobileWeb;
    pageId: string;
    isMobile: boolean;
}

const mapStoreStateToProps = (storeState: IStoreState) => {
    const appState = storeState?.appState?.appState || {};
    const { persistent320x50AdForMobileWeb, pageId } = appState;

    return {
        persistent320x50AdForMobileWeb,
        pageId
    };
};

const mapDispatchToProps = {};

export const Persistent320x50MobileWebAd = withScreenSize(reduxConnect(mapStoreStateToProps, mapDispatchToProps)(({ persistent320x50AdForMobileWeb, pageId, isMobile }: Persistent320x50MobileWebAdProps) => {
    
    if (!isMobile 
        || !persistent320x50AdForMobileWeb 
        || !pageId ) {
        return null;
    }

    const pageCfg = getPageCfgToRenderPersistent320x50Ad(persistent320x50AdForMobileWeb, pageId);

    if (!pageCfg || !pageCfg?.IsEnabled) {
        return null;
    }

    return (
        <Container>
            <DisplayAdUnit slotId={pageCfg.SlotId} width={320} height={50} />
        </Container>
    );
}));

const Container = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    background-color: #2F6E8C;
    padding: 7px;
`;